import { INIT_PAGE_STATE } from "../../constant/constant";
import {
  BLOB_SETTING_GET_LIST,
  BLOB_SETTING_GET_LIST_SUCCESS,
  BLOB_SETTING_GET_LIST_ERROR,
  BLOB_SETTING_ADD_EDIT,
  BLOB_SETTING_SAVE_ADD_EDIT,
  BLOB_SETTING_SAVE_ADD_EDIT_SUCCESS,
  BLOB_SETTING_SAVE_ADD_EDIT_ERROR,
  BLOB_SETTING_DELETE,
  BLOB_SETTING_DELETE_SUCCESS,
  BLOB_SETTING_DELETE_ERROR,
} from "./actions";

const INIT_STATE = {
  list: {
    data: null,
    loading: false,
    error: false,
    filter: null,
    orderBy: "id",
    sortedBy: "asc",
    message: null,
    page: INIT_PAGE_STATE,
  },
  addEdit: {
    data: null,
    mode: "add",
    loading: false,
    error: false,
    message: null,
  },
  deleting: {
    data: null,
    loading: false,
    error: false,
    message: null,
    confirmed: false,
  },
};

const blobSettingReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BLOB_SETTING_GET_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          filter: action.payload.filter,
          orderBy: action.payload.orderBy,
          sortedBy: action.payload.sortedBy,
        },
      };

    case BLOB_SETTING_GET_LIST_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          data: action.payload.data.map((t) => {
            return {
              ...t,
              id: Number(t.id),
              ...t.attributes,
            };
          }),
          page: {
            ...state.list.page,
            currentPage: action.payload.meta.pagination.current_page,
            selectedPageSize: action.payload.meta.pagination.per_page,
            totalItem: action.payload.meta.pagination.total_item,
            totalPage: action.payload.meta.pagination.total_page,
            itemCount: action.payload.meta.pagination.item_count,
          },
          loading: false,
          error: false,
          message: null,
        },
      };
    }

    case BLOB_SETTING_GET_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          data: null,
          loading: false,
          error: true,
          page: INIT_PAGE_STATE,
          message: action.payload,
        },
      };

    case BLOB_SETTING_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          mode: action.payload.mode,
          loading: false,
          error: false,
          message: null,
        },
      };

    case BLOB_SETTING_SAVE_ADD_EDIT:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: action.payload.item,
          loading: true,
          error: false,
          message: null,
        },
      };
    case BLOB_SETTING_SAVE_ADD_EDIT_SUCCESS:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          data: null,
          loading: false,
          error: false,
        },
        // Update the list data if it exists (for status update case)
        list: state.list.data ? {
          ...state.list,
          data: state.list.data.map(item => {
            // If this is a status update, find and update the matching item
            const updatedId = action.payload?.data?.id;
            if (updatedId && item.id === updatedId) {
              return {
                ...item,
                status: action.payload.data.status
              };
            }
            return item;
          })
        } : state.list
      };

    case BLOB_SETTING_SAVE_ADD_EDIT_ERROR:
      return {
        ...state,
        addEdit: {
          ...state.addEdit,
          loading: false,
          error: true,
          message: action.payload.toString(),
        },
      };

    case BLOB_SETTING_DELETE:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: action.payload.item,
          confirmed: action.payload.confirmed,
          loading: action.payload.confirmed,
          error: false,
          message: null,
        },
      };

    case BLOB_SETTING_DELETE_SUCCESS:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          data: null,
          loading: false,
          error: false,
          message: null,
          confirmed: false,
        },
      };

    case BLOB_SETTING_DELETE_ERROR:
      return {
        ...state,
        deleting: {
          ...state.deleting,
          loading: false,
          error: true,
          message: action.payload,
          confirmed: false,
        },
      };

    default:
      return state;
  }
};

export default blobSettingReducer;
